import { isObject } from "lodash";

export const goToTop = () => {
   document.getElementById("top").scrollIntoView({ behavior: "smooth", block: "start" });
};

export const refToErrorFormik = formik => {
   if (!formik.isSubmitting) return;
   if (Object.keys(formik.errors).length > 0) {
      if (isObject(formik.errors[Object.keys(formik.errors)[0]])) {
         const objectKEY = Object.keys(formik.errors)[0];
         const objectVALUE = Object.keys(formik.errors[Object.keys(formik.errors)[0]])[0];
         const objectJOIN = `${objectKEY}.${objectVALUE}`;
         document.getElementById(objectJOIN)?.scrollIntoView({ behavior: "smooth", block: "center" });
         document.getElementById(objectJOIN)?.focus();
      } else {
         document.getElementById(Object.keys(formik.errors)[0])?.scrollIntoView({ behavior: "smooth", block: "center" });
         document.getElementById(Object.keys(formik.errors)[0])?.focus();
      }
   }
};

export const fileToBase64 = file => {
   return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
   });
};

export const base64ToFile = (dataurl, filename) => {
   var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

   while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
   }

   return new File([u8arr], filename, { type: mime });
};

export const base64ToFilePdf = data => {
   // const base64WithoutPrefix = data.substr("data:application/pdf;base64,".length);
   const bytes = atob(data);
   let length = bytes.length;
   let out = new Uint8Array(length);

   while (length--) {
      out[length] = bytes.charCodeAt(length);
   }

   return new Blob([out], { type: "application/pdf" });
};

export const verifyToStorage = async data => {
   if (data instanceof File) return await fileToBase64(data);
   return data;
};

export const verifyToNotSaveToStorage = async data => {
   if (data instanceof File) return data;
   else return base64ToFile(data, "file");
};

export const removeDiacritics = str => {
   return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
};

export const removeDiacriticsToUppercase = str => {
   return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase();
};

export const checkIfEmptyObject = value => {
   if (value === null || value === undefined) return true;
   if (typeof value === "object" && Object.keys(value).length === 0 && !(value instanceof File)) return true;
   else return false;
};

export const getSizeOfUpload = async uploadedFile => {
   // Convert base64 string to Blob
   let base64StringFromFile = uploadedFile;
   if (base64StringFromFile instanceof File) {
      base64StringFromFile = await fileToBase64(uploadedFile);
   }
   const byteCharacters = atob(base64StringFromFile.split(",")[1]);
   const byteArrays = [];
   for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
   }
   const blob = new Blob([new Uint8Array(byteArrays)]);

   // Get file size in bytes
   const fileSizeInBytes = blob.size;

   // Convert file size to megabytes (MB)
   const fileSizeInMb = fileSizeInBytes / (1024 * 1024);

   return fileSizeInMb;
};

export const displayCorrectContent = value => {
   if (value === null || value === undefined || (typeof value === "object" && Object.keys(value).length === 0 && !(value instanceof File)))
      return { isPdf: false, imageToDisplay: null };
   if (value instanceof File && value.type === "application/pdf") {
      return { isPdf: true, imageToDisplay: value };
   } else if (typeof value !== "string") {
      return { isPdf: false, imageToDisplay: URL.createObjectURL(value) };
   } else if (value.split(";")[0] === "data:application/pdf") {
      return { isPdf: true, imageToDisplay: value };
   } else {
      return { isPdf: false, imageToDisplay: value };
   }
};

export const getCorrectPdfScale = windowWidth => {
   if (windowWidth > 992) return 1.33;
   if (windowWidth < 992 && windowWidth > 768) return 1.25;
   if (windowWidth < 768 && windowWidth > 600) return 0.96;
   if (windowWidth < 600 && windowWidth > 500) return 0.82;
   if (windowWidth < 500 && windowWidth > 450) return 0.73;
   if (windowWidth < 450 && windowWidth > 400) return 0.65;
   if (windowWidth < 400) return 0.6;
};

const isRomanianHoliday = date => {
   const romanianHolidays = ["01-01", "01-02", "01-24", "04-17", "05-01", "06-01", "06-05", "08-15", "11-30", "12-01", "12-25", "12-26"];
   const day = date.getDate();
   const month = date.getMonth() + 1;
   const dateString = `${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
   return romanianHolidays.includes(dateString);
};

export const addBusinessDays = (date, days) => {
   let addedDays = 0;
   while (addedDays < days) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      const isHoliday = isRomanianHoliday(date);
      if (day !== 6 && day !== 0 && !isHoliday) {
         addedDays++;
      }
   }
   return date;
};

export const getTipCetatenie = () => {
   const sessionStepState = localStorage.getItem("sessionStepsState");
   const parsedSessionStepState = JSON.parse(sessionStepState);
   const tipCetatenie = parsedSessionStepState?.step3.tipCetatenie;

   return tipCetatenie;
};

export const checkDataForStep5_STRAIN = async value => {
   if (value instanceof File) return await fileToBase64(value);
   if (checkIfEmptyObject(value)) return "";
   return value;
};

export const areObjectsEqual = (obj1, obj2) => {
   if (obj1 === obj2) return true;

   if (!obj1 || !obj2) return false;

   if (typeof obj1 !== "object" || typeof obj2 !== "object") return false;

   const keys1 = Object.keys(obj1);
   const keys2 = Object.keys(obj2);

   if (keys1.length !== keys2.length) return false;

   for (let key of keys1) {
      if (!keys2.includes(key)) return false;
      if (!areObjectsEqual(obj1[key], obj2[key])) return false;
   }

   return true;
};
